// extracted by extract-css-chunks-webpack-plugin
module.exports = {"AVATAR_SIZE":"80px","authorImageContainer":"YwlSq6","image":"_3KgbTi","imageWrapper":"_2sWaWa"};